var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 66,
    viewBox: "0 0 62 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2263",
    "data-name": "Raggruppa 2263",
    transform: "translate(-629 -125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1980",
    "data-name": "Raggruppa 1980",
    transform: "translate(-20 -198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_356",
    "data-name": "Rettangolo 356",
    width: 62,
    height: 66,
    rx: 4,
    transform: "translate(649 323)",
    fill: "#5f9e16"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M35.438,6.975a2.083,2.083,0,0,1-.63,1.53L18.518,24.8l-3.06,3.06a2.173,2.173,0,0,1-3.06,0L9.338,24.8,1.192,16.65a2.173,2.173,0,0,1,0-3.06l3.06-3.06a2.083,2.083,0,0,1,1.53-.63,2.083,2.083,0,0,1,1.53.63l6.615,6.638L28.687,2.386a2.173,2.173,0,0,1,3.06,0l3.06,3.06a2.083,2.083,0,0,1,.63,1.53Z",
    transform: "translate(642.438 143.244)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.e56e8024c5b079eff31f9bb490eb761e.svg";
export { ForwardRef as ReactComponent };